var _defs, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.25 60.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3e3f41;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #b58c3e;\n      }\n\n      .cls-3 {\n        fill: #ffc557;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.36 60.8 22.62 55.77 12.88 60.8 12.88 29.69 32.36 29.69 32.36 60.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "12.88 54.2 12.88 60.8 22.62 55.77 32.36 60.8 32.36 54.2 22.62 49.17 12.88 54.2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 22.62,
    cy: 22.62,
    r: 22.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeIcon);
export default __webpack_public_path__ + "static/media/prize_icon.a5087583fea79ff230fa72cf84457011.svg";
export { ForwardRef as ReactComponent };